import { KibContainer } from '@chewy/kib-layout-react'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentRequestScreen.module.scss'

export const PaymentRequestScreen = () => (
  <KibContainer className={styles.paymentRequestScreenContainer}>
    <div>Payment Request Screen</div>
  </KibContainer>
)
